export enum ModalCloseType {
  Normal = 'Normal', // close modal by cross, escape, click outside
  Safe = 'Safe', // close modal by cross
}
